import { useTranslations } from "@acto/web-common/locales";
import { UndoToast, UndoToastSlot } from "@acto/taskpane/field-sales-2/components/primitives/Toast";

interface TodoUndoToastsProps {
  completionPendingCount: number;
  onUndoCompletion: () => void;
  revertPendingCount: number;
  onUndoRevert: () => void;
  reassignPendingCount: number;
  onUndoReassignment: () => void;
}

export function TodoUndoToasts({
  completionPendingCount,
  onUndoCompletion,
  revertPendingCount,
  onUndoRevert,
  reassignPendingCount,
  onUndoReassignment,
}: TodoUndoToastsProps) {
  const t = useTranslations("fieldSalesTwo.todosList");

  return (
    <UndoToastSlot>
      {completionPendingCount > 0 && (
        <UndoToast
          message={t("completedToast", { count: completionPendingCount })}
          undoLabel={t("undo")}
          onUndo={onUndoCompletion}
        />
      )}
      {revertPendingCount > 0 && (
        <UndoToast
          message={t("reopenedToast", { count: revertPendingCount })}
          undoLabel={t("undo")}
          onUndo={onUndoRevert}
        />
      )}
      {reassignPendingCount > 0 && (
        <UndoToast
          message={t("reassignedToast", { count: reassignPendingCount })}
          undoLabel={t("undo")}
          onUndo={onUndoReassignment}
        />
      )}
    </UndoToastSlot>
  );
}
